import { useState } from "react";

// 5 emoji corrispondenti ai rating 1..5
const EMOJIS = [
  { value: 1, char: "😞", label: "Molto male" },
  { value: 2, char: "😐", label: "Non bene" },
  { value: 3, char: "🙂", label: "Nella media" },
  { value: 4, char: "😊", label: "Bene" },
  { value: 5, char: "🤩", label: "Molto bene" },
];

/**
 * EmojiRating — 5 emoji cliccabili (opzionali). value = null significa "non risposto".
 * Doppio-click sulla stessa scelta la deseleziona (torna null).
 */
export function EmojiRating({ value = null, onChange, testIdPrefix = "emoji-rating", disabled = false }) {
  const [hover, setHover] = useState(null);
  const active = hover ?? value;
  return (
    <div className="inline-flex items-center gap-1.5 sm:gap-2" role="radiogroup">
      {EMOJIS.map((e) => {
        const isSelected = value === e.value;
        const isDim = active !== null && active !== e.value;
        return (
          <button
            key={e.value}
            type="button"
            disabled={disabled}
            data-testid={`${testIdPrefix}-${e.value}`}
            aria-label={e.label}
            aria-pressed={isSelected}
            onMouseEnter={() => setHover(e.value)}
            onMouseLeave={() => setHover(null)}
            onClick={() => onChange?.(isSelected ? null : e.value)}
            title={e.label}
            className={[
              "text-2xl sm:text-3xl leading-none transition-all rounded-full p-1",
              disabled ? "cursor-default" : "cursor-pointer hover:scale-110",
              isSelected ? "ring-2 ring-[#C05C45] ring-offset-2 ring-offset-white bg-[#FAF0EC]" : "",
              isDim ? "opacity-40 grayscale" : "",
            ].join(" ")}
          >
            <span aria-hidden="true">{e.char}</span>
          </button>
        );
      })}
    </div>
  );
}

/** Read-only mini display (per ReviewCard) */
export function EmojiRatingDisplay({ value, size = "text-lg" }) {
  if (!value) return <span className="font-ui text-xs text-[#8A9691]">—</span>;
  const e = EMOJIS.find((x) => x.value === value);
  if (!e) return null;
  return (
    <span title={e.label} aria-label={e.label} className={`${size} leading-none`}>
      {e.char}
    </span>
  );
}
